invHdApp.controller('OrderListController', ['$scope', 'Order', '$location', '$filter', '$routeParams', '$rootScope', 'User', '$timeout', '$http',
	function ($scope, Order, $location, $filter, $routeParams, $rootScope, User, $timeout, $http) {

		$scope.filterProp = [];
		$scope.selectedItem = [];

		// RootScope değişkenlerini başlat
		$rootScope.realOrder = true;
		$rootScope.returnOrder = false;
		$rootScope.transferOrder = false;
		$rootScope.notesOrder = false;
		
		// Scope değişkenlerini de başlat
		$scope.realOrder = true;
		$scope.returnOrder = false;
		$scope.transferOrder = false;
		$scope.notesOrder = false;
		
		console.log('Initial values - realOrder:', $rootScope.realOrder, 'returnOrder:', $rootScope.returnOrder, 'transferOrder:', $rootScope.transferOrder, 'notesOrder:', $rootScope.notesOrder);

		// Get authenticated user data
		if (!$rootScope.authenticatedUser) {
			User.getUser().success(function(data) {
				$rootScope.authenticatedUser = data; // data.user değil, direkt data
				console.log('Authenticated User:', $rootScope.authenticatedUser);
				console.log('User ID:', $rootScope.authenticatedUser.user_id);
				console.log('User ID type:', typeof $rootScope.authenticatedUser.user_id);
			});
		} else {
			console.log('Authenticated User (cached):', $rootScope.authenticatedUser);
			console.log('User ID:', $rootScope.authenticatedUser.user_id);
			console.log('User ID type:', typeof $rootScope.authenticatedUser.user_id);
		}

		$scope.calendarView = 'month';

	$scope.addSelectedItem = function (item) {

		if ($scope.selectedItem.indexOf(item) > -1) {
			$scope.selectedItem.splice($scope.selectedItem.indexOf(item), 1);
			// Eğer tüm checkbox'lar kaldırıldıysa master'ı false yap
			if ($scope.selectedItem.length === 0) {
				$scope.master = false;
			}
		} else {
			$scope.selectedItem.push(item);
		}
	}

	$scope.selectAllOrders = function (select) {
		if (select) {
			$scope.selectedItem = [];
			$scope.filterData.selectAll = true;
			$scope.master = true; // Checkbox'ları işaretlemek için
			$scope.orders();
		} else {
			$scope.selectedItem = [];
			$scope.master = false;
		}
	};

	$scope.selectAll = function (select) {
		if (select) {
			$scope.selectedItem = [];
			$scope.master = true; // Checkbox'ları işaretlemek için
			for (let i = 0; i < $scope.data.orders.data.length; i++) {
				if ($scope.data.orders.data[i].location && $scope.data.orders.data[i].location.name) {
					$scope.selectedItem.push($scope.data.orders.data[i].id);
				}
			}
		} else {
			$scope.selectedItem = [];
			$scope.master = false;
		}
	};

		$scope.$on('updateOrder', function (event, data, nextParams, fromState) {
			var order = find($scope.data.orders.data, data.id);
			angular.merge(order, data);
			// $scope.createOrderMarker(order);
		});

	function find(data, find) {
		var index = data.indexOf($filter('filter')(data, {
			id: find
		})[0]);
		if (index > -1)
			return data[index];
	}

	$scope.filterData = {
		term: '',
		stations: [],
		customers: [],
		customersSelected: [], // Company 87 için autocomplete ile seçilen müşteriler (obje array)
		companies: [],
		workers: [],
		plates: [],
		workSteps: [],
		workTypes: [],
		order_payment: [],
		city: [],
		district: [],
		neighbourhoods: [],
		has_location: '',
		has_worker: '',
		source: [], // Koçtaş/Trendyol kaynak filtresi
		exitStations: [], // Varış şubesi filtresi
		page: 1,
		created_at: {
			startDate: null,
			endDate: null
		},
		scheduled_time: {
			startDate: null,
			endDate: null
		}
	}

	// Company 87 için autocomplete ile seçilen müşterileri ID array'ine çevir
	$scope.updateCustomerFilter = function() {
		if ($scope.filterData.customersSelected && $scope.filterData.customersSelected.length > 0) {
			$scope.filterData.customers = $scope.filterData.customersSelected.map(function(customer) {
				return customer.id;
			});
		} else {
			$scope.filterData.customers = [];
		}
	}

	// Müşteri arama fonksiyonu (autocomplete için)
	var lastType = '';
	$scope.searchRes = [];
	$scope.customerDropdownOpen = false;
	
	// Use object to avoid scope inheritance issues with primitives
	$scope.customerSearch = {
		term: ''
	};
	
	// Direct search function
	$scope.searchCustomerNow = function() {
		var searchTerm = $scope.customerSearch.term;
		
		if (!searchTerm || searchTerm.length < 2) {
			$scope.searchRes = [];
			return;
		}
		
		$http.get('api/find-customer', {
			params: {
				s: searchTerm,
				type: 'corporate'
			},
			ignoreLoadingBar: true
		}).then(function (response) {
			$scope.searchRes = response.data.customers || [];
		}).catch(function(error) {
			$scope.searchRes = [];
		});
	}
	
	var searchTimeout;
	$scope.$watch('customerSearch.term', function(newVal, oldVal) {
		if (newVal === oldVal && oldVal !== undefined) return;
		
		// Cancel previous timeout
		if (searchTimeout) {
			$timeout.cancel(searchTimeout);
		}
		
		if (!newVal || newVal.length < 2) {
			$scope.searchRes = [];
			return;
		}
		
		// Debounce 300ms
		searchTimeout = $timeout(function() {
			$scope.searchCustomerNow();
		}, 300);
	});
	
	$scope.toggleCustomerDropdown = function() {
		console.log('toggleCustomerDropdown called, current state:', $scope.customerDropdownOpen);
		$scope.customerDropdownOpen = !$scope.customerDropdownOpen;
		console.log('New state:', $scope.customerDropdownOpen);
		if (!$scope.customerDropdownOpen) {
			$scope.customerSearch.term = '';
			$scope.searchRes = [];
		}
	}
	
	$scope.isCustomerSelected = function(customer) {
		if (!$scope.filterData.customersSelected) return false;
		return $scope.filterData.customersSelected.some(function(c) {
			return c.id === customer.id;
		});
	}
	
	$scope.toggleCustomerSelection = function(customer) {
		if (!$scope.filterData.customersSelected) {
			$scope.filterData.customersSelected = [];
		}
		
		var index = $scope.filterData.customersSelected.findIndex(function(c) {
			return c.id === customer.id;
		});
		
		if (index > -1) {
			$scope.filterData.customersSelected.splice(index, 1);
		} else {
			$scope.filterData.customersSelected.push(customer);
		}
		
		$scope.updateCustomerFilter();
	}
	
	$scope.clearCustomerFilter = function() {
		$scope.filterData.customersSelected = [];
		$scope.filterData.customers = [];
		$scope.customerSearch.term = '';
		$scope.searchRes = [];
		$scope.customerDropdownOpen = false;
	}
	
	// Dropdown dışına tıklandığında kapat
	angular.element(document).on('click', function(event) {
		var isClickInside = angular.element(event.target).closest('.customer-filter-wrapper').length > 0;
		if (!isClickInside && $scope.customerDropdownOpen) {
			$scope.$apply(function() {
				$scope.customerDropdownOpen = false;
				$scope.customerSearch.term = '';
				$scope.searchRes = [];
			});
		}
	});

	$scope.addFilterProps = function (item) {
			if ($scope.filterProp.indexOf(item) === -1)
				$scope.filterProp.push(item);
			else {
				var index = $scope.filterProp.indexOf(item);
				$scope.filterProp.splice(index, 1);
				if (item != 'term') {
					$scope.filterData[item] = [];
				} else {
					$scope.filterData[item] = "";
				}
				if (item == 'date') {
					delete $scope.filterData.startDate;
					delete $scope.filterData.endDate;
				}
				if ($scope.filterProp.length == 0) {
					$scope.filter('clear');
				}
			}
		}

		$scope.getPage = function (page) {
			$scope.filterData.page = page;
			$scope.filter();
		}

		$scope.sort = function (field, sort) {
			$scope.filterData.field = field;
			$scope.filterData.sort = sort;
			$scope.filter();
		}

	$scope.filter = function (type) {
		if (type == 'clear') {
			$scope.filterData = {
				customers: [],
				customersSelected: [], // Company 87 için autocomplete - temizle
				workers: [],
				workSteps: [],
				exitStations: [], // Varış şubesi filtresi
				page: 1,
				created_at: {
					startDate: null,
					endDate: null
				},
				scheduled_time: {
					startDate: null,
					endDate: null
				}
			}
			$scope.filterProp = [];
			} else {
				$scope.filterData.filterProp = $scope.filterProp;
				if (typeof $scope.filterData.created_at.endDate !== 'undefined' && $scope.filterData.created_at.endDate !== null) {
					$scope.filterData.filterProp.created_at = 'created_at';
				}
				if (typeof $scope.filterData.scheduled_time.endDate !== 'undefined' && $scope.filterData.scheduled_time.endDate !== null) {
					$scope.filterData.filterProp.scheduled_time = 'scheduled_time';
				}
			}
			$scope.orders();
		}

		$scope.$on('refresh_data', function () {
			console.log('refreshing list...')
			$scope.filterData.page = 1
			$scope.orders();
		}, true);

		$scope.searchOrder = function (term) {
			// Normal orders endpoint'ini kullan - term filtresi ile
			$scope.filterData.term = term;
			$scope.orders();
		}

		$scope.refreshData = function () {
			// Her zaman normal orders endpoint'ini kullan
			$scope.isSearchMode = false;
			$scope.searchResults = 0;
			
			// Loading indicator göster
			$scope.isLoading = true;
			
			$scope.orders();
		}

		$scope.navigateToOrders = function (params) {
			console.log('=== navigateToOrders called ===');
			console.log('Params:', params);
			console.log('Before - realOrder:', $rootScope.realOrder, 'returnOrder:', $rootScope.returnOrder, 'transferOrder:', $rootScope.transferOrder, 'notesOrder:', $rootScope.notesOrder);
			
		// Loading indicator göster
		$scope.isLoading = true;
		
		// Filtreleri temizle
		$scope.filterData = {
			term: '',
			stations: [],
			customers: [],
			customersSelected: [], // Company 87 için autocomplete
			companies: [],
			workers: [],
			plates: [],
			workSteps: [],
			workTypes: [],
			order_payment: [],
			city: [],
			district: [],
			neighbourhoods: [],
			has_location: '',
			has_worker: '',
			source: [], // Koçtaş/Trendyol kaynak filtresi
			exitStations: [], // Varış şubesi filtresi
				page: 1,
				created_at: {
					startDate: null,
					endDate: null
				},
				scheduled_time: {
					startDate: null,
					endDate: null
				}
			};
			
			// Seçim durumlarını temizle
			$scope.selectedItem = [];
			$scope.master = false;
			
			// Parametreleri ekle ve rootScope'u güncelle
			if (params) {
				var paramPairs = params.split('&');
				for (var i = 0; i < paramPairs.length; i++) {
					var pair = paramPairs[i].split('=');
					if (pair.length === 2) {
						$scope.filterData[pair[0]] = pair[1] === 'true' ? true : pair[1];
						
						// RootScope ve Scope değişkenlerini güncelle
						if (pair[0] === 'real_order') {
							$rootScope.realOrder = pair[1] === 'false' ? false : true;
							$scope.realOrder = $rootScope.realOrder;
							// Diğer filtreleri temizle
							$rootScope.returnOrder = false;
							$rootScope.transferOrder = false;
							$rootScope.notesOrder = false;
							$scope.returnOrder = false;
							$scope.transferOrder = false;
							$scope.notesOrder = false;
						} else if (pair[0] === 'return_order') {
							$rootScope.returnOrder = pair[1] === 'true';
							$scope.returnOrder = $rootScope.returnOrder;
							// Return order seçildiğinde diğerlerini temizle
							if (pair[1] === 'true') {
								$rootScope.realOrder = true;
								$rootScope.transferOrder = false;
								$rootScope.notesOrder = false;
								$scope.realOrder = true;
								$scope.transferOrder = false;
								$scope.notesOrder = false;
							}
						} else if (pair[0] === 'transfer_order') {
							$rootScope.transferOrder = pair[1] === 'true';
							$scope.transferOrder = $rootScope.transferOrder;
							// Transfer order seçildiğinde diğerlerini temizle
							if (pair[1] === 'true') {
								$rootScope.realOrder = true;
								$rootScope.returnOrder = false;
								$rootScope.notesOrder = false;
								$scope.realOrder = true;
								$scope.returnOrder = false;
								$scope.notesOrder = false;
							}
						} else if (pair[0] === 'notes') {
							$rootScope.notesOrder = pair[1] === 'true';
							$scope.notesOrder = $rootScope.notesOrder;
							// Notes order seçildiğinde diğerlerini temizle
							if (pair[1] === 'true') {
								$rootScope.realOrder = true;
								$rootScope.returnOrder = false;
								$rootScope.transferOrder = false;
								$scope.realOrder = true;
								$scope.returnOrder = false;
								$scope.transferOrder = false;
							}
						}
					}
				}
			} else {
				// Tüm rootScope ve scope değişkenlerini temizle
				$rootScope.realOrder = true;
				$rootScope.returnOrder = false;
				$rootScope.transferOrder = false;
				$rootScope.notesOrder = false;
				$scope.realOrder = true;
				$scope.returnOrder = false;
				$scope.transferOrder = false;
				$scope.notesOrder = false;
			}
			
			console.log('After - realOrder:', $rootScope.realOrder, 'returnOrder:', $rootScope.returnOrder, 'transferOrder:', $rootScope.transferOrder, 'notesOrder:', $rootScope.notesOrder);
			console.log('=== navigateToOrders end ===');
			
			// Asenkron olarak sayfayı güncelle
			$timeout(function() {
				// Değişiklikleri $timeout içinde yap
				$rootScope.$apply();
				$scope.orders();
			}, 0);
		}



	$scope.clearFilter = function (page) {
		// Mevcut real_order, return_order, transfer_order, notes parametrelerini sakla
		var currentRealOrder = $scope.filterData.real_order;
		var currentReturnOrder = $scope.filterData.return_order;
		var currentTransferOrder = $scope.filterData.transfer_order;
		var currentNotes = $scope.filterData.notes;
		
		$scope.filterData = {
			term: '',
			stations: [],
			customers: [],
			customersSelected: [], // Company 87 için autocomplete - temizle
			companies: [],
			workers: [],
			plates: [],
			workSteps: [],
			workTypes: [],
			order_payment: [],
			city: [],
			district: [],
			neighbourhoods: [],
			has_location: '',
			has_worker: '',
			source: [], // Koçtaş/Trendyol kaynak filtresi
			exitStations: [], // Varış şubesi filtresi
			page: 1,
			created_at: {
				startDate: null,
				endDate: null
			},
			scheduled_time: {
				startDate: null,
				endDate: null
			}
		};
		
		// Saklanan parametreleri geri yükle
		if (typeof currentRealOrder !== 'undefined') {
			$scope.filterData.real_order = currentRealOrder;
		}
		if (typeof currentReturnOrder !== 'undefined') {
			$scope.filterData.return_order = currentReturnOrder;
		}
		if (typeof currentTransferOrder !== 'undefined') {
			$scope.filterData.transfer_order = currentTransferOrder;
		}
		if (typeof currentNotes !== 'undefined') {
			$scope.filterData.notes = currentNotes;
		}
		
		// Seçim durumlarını temizle
		$scope.selectedItem = [];
		$scope.master = false;
		
		console.log('clearFilter - restored real_order:', $scope.filterData.real_order);
		
		$scope.filterProp = [];
		$scope.isSearchMode = false;
		$scope.searchResults = 0;
		$scope.orders();
	}

	$scope.orders = function () {
		if ($routeParams.invoice_id) {
			$scope.filterData.invoice_id = $routeParams.invoice_id;
		}
		if ($routeParams.route_optimization_id) {
			$scope.filterData.route_optimization_id = $routeParams.route_optimization_id;
		}

		if ($routeParams.order_id) {
			$scope.getOrderDetails($routeParams.order_id);
		}
		
		// real_order parametresini kontrol et - öncelikle filterData'dan, yoksa routeParams'dan
		if (typeof $scope.filterData.real_order !== 'undefined') {
			// filterData'da varsa onu kullan (navigateToOrders ile set edilmiş)
			$rootScope.realOrder = $scope.filterData.real_order === true || $scope.filterData.real_order === 'true';
			console.log('real_order from filterData:', $scope.filterData.real_order, 'rootScope.realOrder:', $rootScope.realOrder);
		} else if ($routeParams.real_order) {
			// filterData'da yoksa routeParams'dan al
			$scope.filterData.real_order = true;
			$rootScope.realOrder = true;
			console.log('real_order from routeParams: true');
		} else {
			// Her ikisinde de yoksa false
			if (typeof $scope.filterData.real_order === 'undefined') {
				$rootScope.realOrder = false;
				console.log('real_order default: false');
			}
		}
			if ($routeParams.return_order) {
				$scope.filterData.return_order = true;
				$rootScope.returnOrder = true;
			} else {
				$rootScope.returnOrder = false;
			}
			if ($routeParams.transfer_order) {
				$scope.filterData.transfer_order = true;
				$rootScope.transferOrder = true;
			} else {
				$rootScope.transferOrder = false;
			}
			if ($routeParams.notes) {
				$scope.filterData.notes = true;
				$rootScope.notesOrder = true;
			} else {
				$rootScope.notesOrder = false;
			}
			Order.orders($scope.filterData).success(function (data, status, headers, config) {
				// Asenkron olarak DOM'u güncelle - Firefox donmasını önler
				$timeout(function() {
					if ($scope.filterData.selectAll) {
						// selectAll durumunda API pluck type kullanıyor ve direkt order ID array'i döndürüyor
						// Bu durumda data.orders direkt bir array (Collection) olacak
						// Ama UI'da checkbox'ları göstermek için normal paginated response'a ihtiyacımız var
						// Bu yüzden selectAll flag'ini silip normal istek gönderiyoruz
						delete $scope.filterData.selectAll;
						// Normal istek gönder ki checkbox'lar görünsün
						$scope.master = true; // Checkbox'ları işaretli göster
						// selectedItem'ı boş bırak, sendOrdersToMove çağrıldığında API'ye tekrar istek gönderecek
						$scope.selectedItem = [];
						
						// Normal paginated response için tekrar istek gönder
						var normalFilterData = angular.copy($scope.filterData);
						Order.orders(normalFilterData).success(function (normalData) {
							$scope.data = normalData;
							if ($rootScope.realOrder) {
								$scope.data.steps.unshift({
									id: 0,
									name: 'Oluşturuldu'
								});
							}
						});
					} else {
						$scope.data = data;
						if ($rootScope.realOrder) {
							$scope.data.steps.unshift({
								id: 0,
								name: 'Oluşturuldu'
							});
						}

						angular.merge($scope.filterData, $routeParams);
						if (typeof $scope.filterData.filterProp !== 'undefined') {
							$scope.filterProp = [];
							if (angular.isArray($scope.filterData.filterProp)) {
								for (var i = $scope.filterData.filterProp.length - 1; i >= 0; i--) {
									$scope.filterProp.push($scope.filterData.filterProp[i])
								}
							} else {
								$scope.filterProp.push($scope.filterData.filterProp);
							}
						}
					}
					
					// Loading'i kapat
					$scope.isLoading = false;
				}, 0);
			}).error(function() {
				$scope.isLoading = false;
			});
		};

		$scope.downloadZip = function () {

			Order.generateTotalOrdersReportInZip({ orders: $scope.selectedItem }).success(function (data, status, headers, config) {
				window.location.href = data['url'];
				setTimeout(function () {
					Order.removeDownloadFile({ path: data['path'] }).success(function (response, status, headers, config) {
						$scope.selectedItem = [];
					});
				}, 2000)
			});

		};

		$scope.downloadExcel = function () {
			data = $scope.filterData;
			data.orders = $scope.selectedItem;
			Order.generateExcelReport(data).success(function (data, status, headers, config) {
				window.location.href = data['url'];
				// setTimeout(function(){
				// 	Order.removeDownloadFile({path: data['path']}).success(function(response, status, headers, config) {	
				// 		$scope.selectedItem = [];
				// 	});
				// },2000)
			});
		};

	$scope.toggleSelection = function toggleSelection(event) {
		if (event.target.checked) {
			$scope.selectedItem = [];
			$scope.master = true; // Checkbox'ları işaretlemek için
			for (var i = 0; i < $scope.data.orders.data.length; i++) {

				$scope.selectedItem.push($scope.data.orders.data[i].id);
			}
		} else {
			$scope.selectedItem = [];
			$scope.master = false;
		}
	};

		$scope.deleteOrders = function (send_cancel_sms) {
			Order.deleteOrders({ orders: $scope.selectedItem, send_cancel_sms: send_cancel_sms }).success(function (response, status, headers, config) {
				$scope.orders();
				$scope.selectedItem = [];
				$('#deleteOrdersModal').modal('toggle');
			});
		}

		$scope.company_id;
		$scope.assignOrders = function (company_id) {
			Order.assigOrders({ orders: $scope.selectedItem, company_id: $scope.company_id }).success(function (response, status, headers, config) {
				$scope.orders();
				$scope.selectedItem = [];
				Messenger().post('İşler seçtiğiniz müşteriye başarıyla atanmıştır!');
				$('#assignOrdersModal').modal('toggle');
			});
		}

		$scope.route_optimization_id;
		$scope.assignOrdersRoute = function () {
			Order.assigOrdersRoute({ orders: $scope.selectedItem, route_optimization_id: $scope.route_optimization_id }).success(function (response, status, headers, config) {
				$scope.orders();
				$scope.selectedItem = [];
				Messenger().post('İşler seçtiğiniz rotaya başarıyla atanmıştır!');
				$('#assignOrdersRouteModal').modal('toggle');
			});
		}

		$scope.workerIds;
		$scope.plate_id;
		$scope.assignworker = {
			workerIds: null,
			plate_id: null,
		}

		$scope.handlePlate = function () {
			var findPlate = $scope.filterPlates.filter(i => i.worker_id == $scope.workerIds);
			console.log(findPlate);
			if (findPlate.length > 0) {
				$scope.plate_id = findPlate[0].id.toString();
				setTimeout(() => {
					$('.selectpicker').selectpicker('refresh');
				}, 100);
			}
		};

		$scope.assignWorkerModel = function () {
			// "Hepsini seç" (master) durumunda selectedItem boş kalabiliyor.
			// Bu durumda ID'leri client'a çekmeden backend'de selectAll + filter ile bulk assign yap.
			var payload = {
				worker_id: $scope.workerIds,
				plate_id: $scope.plate_id
			};

			if ($scope.master) {
				var filterDataCopy = angular.copy($scope.filterData);
				filterDataCopy.selectAll = true;
				// Pagination'ı kaldır ki tüm order setine uygulasın
				delete filterDataCopy.page;
				angular.extend(payload, filterDataCopy);
			} else {
				payload.ids = $scope.selectedItem;
			}

			$scope.isLoading = true;
			Order.assignWorker(payload).success(function (response, status, headers, config) {
				$scope.orders();
				$scope.selectedItem = [];
				$scope.master = false;
				Messenger().post('İşler seçtiğiniz kuryeye başarıyla atanmıştır!');
				$('#assignWorkerModelModal').modal('toggle');
			}).error(function (data) {
				$scope.isLoading = false;
				Messenger().post({
					message: (data && data.message) ? data.message : 'Kurye atama sırasında bir hata oluştu.',
					type: 'error'
				});
			});
		}

		$scope.orderStatus;
		$scope.changeOrderStatus = function () {
			// Eğer master true ise (tümünü seç durumu), backend'e selectAll gönder
			if ($scope.master) {
				var filterDataCopy = angular.copy($scope.filterData);
				filterDataCopy.selectAll = true;
				delete filterDataCopy.page;
				filterDataCopy.status = $scope.orderStatus.id;
				
				$scope.isLoading = true;
				Order.changeOrderStatus(filterDataCopy).success(function (response, status, headers, config) {
					$scope.orders();
					$scope.selectedItem = [];
					$scope.master = false;
					Messenger().post('İşlerin durumu başarıyla değiştirilmiştir!');
					$('#changeOrderStatusModal').modal('toggle');
				}).error(function (data) {
					$scope.isLoading = false;
					Messenger().post({
						message: data.message || 'Durum değiştirme sırasında bir hata oluştu.',
						type: 'error'
					});
				});
			} else {
				// Normal durumda seçili order'ları gönder
				if ($scope.selectedItem.length === 0) {
					Messenger().post({
						message: 'Lütfen en az bir iş seçin.',
						type: 'error'
					});
					return;
				}
				Order.changeOrderStatus({ ids: $scope.selectedItem, status: $scope.orderStatus.id }).success(function (response, status, headers, config) {
					$scope.orders();
					$scope.selectedItem = [];
					Messenger().post('İşlerin durumu başarıyla değiştirilmiştir!');
					$('#changeOrderStatusModal').modal('toggle');
				});
			}
		}
		
		$scope.sendOffer = function (send_cancel_sms) {
			Order.sendOffer({ orders: $scope.selectedItem }).success(function (response, status, headers, config) {
				$scope.orders();
				$scope.selectedItem = [];
				Messenger().post('Selected orders changed as offer!');
			});
		}

		$scope.sendOrdersToMove = function (ids) {
			// Eğer master true ise (tümünü seç durumu), API'ye tekrar istek gönder ve tüm order ID'lerini al
			if ($scope.master) {
				// selectAll durumunda API'ye tekrar istek gönder ve tüm order ID'lerini al
				var filterDataCopy = angular.copy($scope.filterData);
				filterDataCopy.selectAll = true;
				// Pagination'ı kaldır ki tüm order'ları alsın
				delete filterDataCopy.page;
				Order.orders(filterDataCopy).success(function (data) {
					var allOrderIds = [];
					// selectAll durumunda API pluck type kullanıyor ve direkt order ID array'i döndürüyor
					if (data.orders && Array.isArray(data.orders)) {
						// Direct array response (selectAll durumunda API sadece ID'leri döndürür)
						allOrderIds = data.orders;
					} else if (data.orders && data.orders.data && Array.isArray(data.orders.data)) {
						// Paginated response (normal durum)
						for (let i = 0; i < data.orders.data.length; i++) {
							if (data.orders.data[i].location && data.orders.data[i].location.name) {
								allOrderIds.push(data.orders.data[i].id);
							}
						}
					}
					
					if (allOrderIds.length > 0) {
						$location.url('/order-move?ids=' + allOrderIds.join(','));
					} else {
						Messenger().post({
							message: 'Gönderilecek iş bulunamadı.',
							type: 'error'
						});
					}
				}).error(function (data) {
					console.error('Orders fetch error:', data);
					Messenger().post({
						message: data.message || 'İşler alınırken bir hata oluştu.',
						type: 'error'
					});
				});
			} else {
				// Normal durumda seçili order'ları gönder
				if (ids && ids.length > 0) {
					$location.url('/order-move?ids=' + ids.join(','));
				} else {
					Messenger().post({
						message: 'Lütfen en az bir iş seçin.',
						type: 'error'
					});
				}
			}
		}

	$scope.toggleSelectionCustomer = function (event) {
		if (event.target.checked) {
			$scope.selectedItem = [];
			$scope.master = true; // Checkbox'ları işaretlemek için
			for (var i = 0; i < $scope.data.orders.data.length; i++) {
				// if($scope.data.orders.data[i].status) {
				// 	if($scope.data.orders.data[i].status.id != $scope.data.success.id && $scope.data.orders.data[i].status.id != $scope.data.fail.id) {
				// 		$scope.selectedItem.push($scope.data.orders.data[i].id);
				// 	}
				// }else {
				$scope.selectedItem.push($scope.data.orders.data[i].id);
				// }

			}
		} else {
			$scope.selectedItem = [];
			$scope.master = false;
		}
		};

		$scope.completeOrdersWithoutSms = function () {
			// Eğer master true ise (tümünü seç durumu), API'ye tekrar istek gönder ve tüm order ID'lerini al
			if ($scope.master) {
				// ID'leri client'a çekmek büyük seçimde UI'ı dondurabiliyor.
				// Bu yüzden selectAll + filtreleri backend'e gönderip orada bulk complete yapıyoruz.
				var filterDataCopy = angular.copy($scope.filterData);
				filterDataCopy.selectAll = true;
				delete filterDataCopy.page;
				
				$scope.isLoading = true;
				Order.updateOrderWithoutSms(filterDataCopy).success(function (response) {
					console.log('Update response:', response);
					$scope.orders();
					$scope.selectedItem = [];
					$scope.master = false;
					Messenger().post('İşler başarıyla tamamlandı olarak işaretlendi!');
				}).error(function (data) {
					console.error('Update error:', data);
					$scope.isLoading = false;
					Messenger().post({
						message: data.message || 'Bir hata oluştu.',
						type: 'error'
					});
				});
			} else {
				// Normal durumda seçili order'ları gönder
				if ($scope.selectedItem.length === 0) {
					Messenger().post({
						message: 'Lütfen en az bir iş seçin.',
						type: 'error'
					});
					return;
				}
				console.log('Sending orders to update:', $scope.selectedItem);
				Order.updateOrderWithoutSms({ orders: $scope.selectedItem }).success(function (response) {
					console.log('Update response:', response);
					$scope.orders();
					$scope.selectedItem = [];
					Messenger().post('İşler başarıyla tamamlandı olarak işaretlendi!');
				}).error(function (data) {
					console.error('Update error:', data);
					Messenger().post({
						message: data.message || 'Bir hata oluştu.',
						type: 'error'
					});
				});
			}
		};
	}
]);